<app-tile-layout [maxCols]="maxCols">
  <app-key-stat-tile class="key-stat-tile-group" *ngFor="let keyStat of keyStats" [keyStat]="keyStat"></app-key-stat-tile>
</app-tile-layout>
